import { gql } from '@apollo/client';


export default gql`
    query FETCH_AVAILABLE_MENU_DATES(
        $subdivision: countrySubdivision
    ) {
        menuDates(
            subdivision: $subdivision
        ) {
            dates {
                startDate
                eeAvailableDates
                everydayAvailableDates
                trialAvailableDates
                premiumAvailableDates
                topAvailableDates
                zapasAvailableDates

                setsAvailableDates @client
                allAvailableDates @client
            }
            subdivision
        }
    }
`;

export const MenuDatesCustomizationQuery = gql`
    query MenuDatesCustomizationQuery {
        viewCustomizationComment {
            comment
            type
            id
            reason
        }

        user {
            id
            customizationTagsDetailed {
                id
                title
            }
            filterTags
            lastCustomizationComment
        }
    }
`;
